import { useQuery } from "@tanstack/react-query";
import {
  getChatHistoryService,
  getTargetCountService,
} from "../api/ChatHistoryApi";

export const useChatHistory = (data) => {
  const {
    data: chatHistoryData,
    isLoading: isHistoryLoading,
    isError: isHistoryError,
  } = useQuery({
    queryKey: ["chat-history", data],
    queryFn: () => getChatHistoryService(data),
  });
  return {
    chatHistoryData,
    isHistoryLoading,
    isHistoryError,
  };
};

export const useTargetCount = (target) => {
  const {
    data: targetCountData,
    isLoading: isTargetCountLoading,
    isError: isTargetCountError,
  } = useQuery({
    queryKey: ["target-count", target],
    queryFn: () => getTargetCountService(target),
  });
  return {
    targetCountData,
    isTargetCountLoading,
    isTargetCountError,
  };
};
